import _ from 'lodash'

export function hasTorch () {
  if (navigator && navigator.mediaDevices && _.isFunction(navigator.mediaDevices.getSupportedConstraints)) {
    return navigator.mediaDevices.getSupportedConstraints().torch
  }
}
